import customerRegex from '@zenbusiness/browserslist-config/customer-regex';

function isIphoneOrIpadOrMac() {
  const userAgent = navigator.userAgent.toLowerCase();
  return /iphone|ipad|macintosh/.test(userAgent);
}

/**
 * Checks if the Safari browser version is earlier than the target version.
 * @param {string} targetVersion - The target version to compare against in the format "major.minor.patch".
 * @returns {boolean} - Returns true if the Safari browser version is earlier than the target version, otherwise returns false.
 */
export function isSafariVersionEarlierThan(targetVersion) {
  if (!isIphoneOrIpadOrMac()) {
    return false;
  }

  const { userAgent } = navigator;
  const safariRegex = /Version\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari/;
  const match = userAgent.match(safariRegex);

  if (match) {
    const [major, minor, patch] = [
      parseInt(match[1], 10),
      parseInt(match[2], 10),
      parseInt(match[3] || 0, 10) // Default to 0 if patch version is missing
    ];

    const [targetMajor, targetMinor, targetPatch] = targetVersion.split('.').map(Number);

    // Compare the major, minor, and patch versions
    if (major < targetMajor) {
      return true;
    }
    if (major === targetMajor) {
      if (minor < targetMinor) {
        return true;
      }
      if (minor === targetMinor) {
        return patch < targetPatch;
      }
    }
  }

  return false;
}

/**
 * Checks if the current browser is not allowed for PDF viewing.
 * @returns {boolean} Returns true if the browser is not allowed for PDF viewing, false otherwise.
 */
export const checkNotAllowedBrowsersForPDF = () => {
  const { userAgent } = navigator;
  return !customerRegex.test(userAgent) || isSafariVersionEarlierThan('15.4.0');
};
